module.exports = __webpack_public_path__ + "img/people4.472497dd.png";